import React from 'react';

export const HorizontalSeparator: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <hr className={`border-t border-neutral dark:border-dark-neutral w-full ${className || ''}`} />
    );
};

export const VerticalSeparator: React.FC<{ className?: string }> = ({ className = '' }) => {
    return (
        <div className={`border-l border-neutral dark:border-dark-neutral mx-2 h-full ${className || ''}`} />
    );
};
